<template>
    <div>
        <div class="d-flex justify-content-center align-items-center vh-100 bg-white">
            <div class="company-details-section-card shadow-none border-0 col-md-8 mx-3 mx-md-auto" v-if="companyDetails && companyDetails.length > 0">
                <b-form @submit.prevent="getCompanyEquipments" class="mx-auto">
                    <b-img :src="companyDetails[0].logo" v-if="companyDetails[0].logo" class="mb-5 maxw-300px w-100"/>
                    <b-form-group :label="$t('companyDetailsPage.equipmentLabel')" label-for="input-1" class="text-left label text-capitalize">
                        <b-form-input type="text" v-model="equipmentNo" class="mb-4 input bg-white" :placeholder="$t('companyDetailsPage.equipmentPlaceholder')"
                            required></b-form-input>
                    </b-form-group>
                    <b-form-group v-if="companyDetails[0].pin_code" :label="$t('companyDetailsPage.pinLabel')" label-for="input-1"
                        class="text-left label text-capitalize">
                        <b-form-input type="text" class="mb-4 input bg-white" :placeholder="$t('companyDetailsPage.pinPlaceholder')" required pattern="\d{4,8}"
                            :title="$t('companyDetailsPage.pinTitle')" v-model="pinNo"></b-form-input>
                    </b-form-group>
                    <b-button type="submit" class="w-100 login" variant="primary">{{ $t('companyDetailsPage.submit') }}</b-button>
                    <p class="text-center mt-4 f-14 text-grey">{{ $t('companyDetailsPage.thankYou') }}</p>
                </b-form>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            companyDetails: null,
            equipmentNo: null,
            pinNo: null
        }
    },
    name: "CompanyDetails",
    methods: {
        ...mapActions(["getCompanyDetails", "getCompanyEquipmentDetails", "setNotification","setCompanyPinCode"]),
        async getCompanyEquipments() {
            if (this.pinNo && this.companyDetails && this.companyDetails.length > 0) {
                if(this.pinNo !== this.companyDetails[0].pin_code){
                await this.setNotification({
                    msg: this.$t('companyDetailsPage.pinInvalid'),
                    type: "error",
                    color: "red",
                });
                return
            }
            else this.setCompanyPinCode(this.pinNo)
            }
            try {
                const data = await this.getCompanyEquipmentDetails({ company: this.companyDetails[0].id, unit_no: this.equipmentNo.toUpperCase() })
                this.$router.push(`/search-equipment?equipment=${data[0].id}`)
            }
            catch (e) {
                await this.setNotification({
                    msg: this.$t('companyDetailsPage.equipmentNotFound'),
                    type: "error",
                    color: "red",
                });
            }
        },
    },
    async mounted() {
        try {
            this.companyDetails = await this.getCompanyDetails({ path: this.$route.params.name })
        }
        catch (e) {
            await this.setNotification({
                msg: this.$t('companyDetailsPage.companyNotFound'),
                type: "error",
                color: "red",
            });
            this.$router.push(`/`)
        }
    }
}
</script>
<style>
.company-details-section {
    height: 100vh;
    align-items: center;
}

.company-details-section-card {
    box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.10);
    border-radius: 5px;
}
.search-equipment-page{
    margin: 0 auto;
}
.company-details-section-card>form, .search-equipment-page, .search_equipment-company {
    width: 640px;
}
.company-details-section-card>form>h1 {
    color: #1B1D21;
    font-weight: 700;
    font-size: 36px;
}
@media (max-width: 991px) {
.company-details-section-card>form, .search-equipment-page,.search_equipment-company {
        width: 100%;
}
.company-details-section-card>form>h1 {
    font-size: 24px;
}
}
@media (max-width: 500px) {
    .company-details-section {
        height: auto;
        align-items: start;
        margin-top: 3rem;
    }

   
}</style>